import {Request} from './Request';
import {ConfigurationKeys} from '../enums/config.keys.enum';

export class ChangeConfigurationRequest implements Request {
    chargePointSelectList: string[];

    private confKey: ConfigurationKeys;
    private customConfKey: string;
    private keyType: string;
    private value: string;
    private customValue: string;

    constructor(chargePointSelectList: string[], confKey?: ConfigurationKeys, customConfKey?: string, keyType?: string, value?: string, customValue?: string) {
        this.chargePointSelectList = chargePointSelectList;
        this.confKey = confKey;
        this.customConfKey = customConfKey;
        this.keyType = keyType;
        this.value = value;
        this.customValue = customValue;
    }

    public toString = (): string => {
        return `ChangeConfigurationRequest (confKey: ${this.confKey},
        customConfKey: ${this.customConfKey}, keyType: ${this.keyType}, value: ${this.value}, customValue: ${this.customValue})`;
    }


    get conf_key(): ConfigurationKeys {
        return this.confKey;
    }

    set conf_key(value: ConfigurationKeys) {
        this.confKey = value;
    }

    get custom_conf_key(): string {
        return this.customConfKey;
    }

    set custom_conf_key(value: string) {
        this.customConfKey = value;
    }

    get key_type(): string {
        return this.keyType;
    }

    set key_type(value: string) {
        this.keyType = value;
    }

    get key_value(): string {
        return this.value;
    }

    set key_value(value: string) {
        this.value = value;
    }
}

/*
* chargePointSelectList: JSON;EVB-P20261797;-
chargePointSelectList: 1
keyType: PREDEFINED
confKey: BlinkRepeat
*
*
*chargePointSelectList: JSON;EVB-P20261797;-
chargePointSelectList: 1
keyType: CUSTOM
customConfKey: customKey
value: customKeyValu
*
* */
